export default defineNuxtPlugin((context: any) => {
  const LOG_LEVEL = {
    INFO: 1,
    WARNING: 2,
    ERROR: 3,
  };
  // シーン関連：
  // DE2とA2コントローラ接続状態
  const DE2_STATUS = {
    OFF: 0, // 接続なし
    ON: 1, // 接続あり
  };
  //
  const CONNECTION_STATUS = {
    OPERATION_NOW: 0, //: 運用中
    STOP_OPERATION: 1, //: 運用停止
    STOP_ANOMALY: 2, //: 異常停止
  };
  const CONNECTION_STATE = {
    CONNECT: 0, // 接続
    DISCONNECT: 1, //: 切断
    STOP_ANOMALY: 2, // バックアップ機のため切断
  };
  const EMIT_STATE = {
    NORMAL: 0, // 正常
    ABNORMAL: 1, // 異常
  };
  const LAMP_STATE = {
    NORMAL: 0, // 正常
    ABNORMAL: 1, // 異常
  };
  //
  const OPERATION_STATUS = {
    IDLE: 0, // :アイドル中 (A2コントローラ制御ステータス：アイドル中)
    PLAY_BODY: 1, // :本体再生中(A2コントローラ制御ステータス：スケジュール再生中、ワンショット接点中、オルタネイト接点中)
    PLAY_PANEL: 2, // :本体パネル再生中 (A2コントローラ制御ステータス：パネル再生中)
    SETTING: 3, // :本体設定中 (A2コントローラ制御ステータス：RDM設定中、ファイル更新中、ソフト更新中、設定終了後指示待ち中、ファイル送信中)
    PLAY_REMOTE: 4, // :リモート再生中 (A2コントローラ制御ステータス：リモート再生中(連動/スタンドアロン))
    COMMUNICATION: 5, // :ストリーミングサーバ通信中 (A2コントローラ制御ステータス：Live再生中)
  };

  // 拡張子種別:
  const EXTEND_TYPE = {
    MP4: 'mp4',
    JPG: 'jpg',
    JPEG: 'jpeg',
    PNG: 'png',
    BMP: 'bmp',
    NONE: '',
  };
  // コンテンツ画面で許可されている拡張子
  const CONTENT_ALLOW_EXTEND_TYPE = {
    MP4: EXTEND_TYPE.MP4,
    JPG: EXTEND_TYPE.JPG,
    JPEG: EXTEND_TYPE.JPEG,
    PNG: EXTEND_TYPE.PNG,
    BMP: EXTEND_TYPE.BMP,
  };

  // 解像度:
  const RESOLUTION = {
    NONE: -1,
    HIGHEST: 0,
    HIGH: 1,
    MEDIUM: 2,
    LOW: 3,
  };
  // シーン作成・編集
  const VIDEO_SETTING = {
    COLOR: 1,
    VIDEO: 2,
  };
  // お気に入り
  const FAVORITE_STATUS = {
    BLANK: -1,
    FALSE: 0,
    TRUE: 1,
  };
  // シーンソートカラム名
  const SCENE_SORT_KEY = {
    BLANK: -1,
    SCENE_NAME: 0,
    FAVORITE: 1,
    CREATION_STATUS: 2,
    SEND_STATUS: 3,
    SCENE_TYPE: 4,
    SCENE_CAPACITY: 5,
    UPDATED_DATE: 6,
  };
  // シーンソートカラム名
  const SCENE_SORT_TYPE = {
    BLANK: -1,
    ASC: 0,
    DESC: 1,
  };
  //
  const CREATION_STATUS = {
    BLANK: -1,
    WAIT: 0,
    SUCCESS: 1,
    NOW: 2,
    FAILED: 3,
  };
  const SEND_STATUS = {
    BLANK: -1,
    NOT: 0,
    NOW: 1,
    SUCCESS: 2,
    FAILED: 3,
    FAILED_A2: 4,
    FAILED_INTERNAL: 5,
    DELETE: 9,
  };
  const SCENE_KIND_STATUS = {
    BLANK: -1,
    NOT: 0,
    CW: 1,
    CLOUD: 2,
    COMPOSITION: 3,
  };
  // 復旧
  const CHECKED_STATUS = {
    BLANK: -1,
    NOT_CHECKED: 0,
    CHECKED: 1,
  };

  const CONTROLLER_SIZE = {
    MIN: 1,
    MAX: 64,
  };
  // 制御グループ削除状態定義
  const DELETION_STATUS = {
    NO_DELETE: 0,
    DELETE_NOW: 1,
    SUCCESS_DELETE: 2,
    ERROR_DELETE: 3,
    SUCCESS_RE_DELETE: 9,
  };
  // コントローラ区別定義
  const CONTROLLER_DIVISION = {
    PARENT: 1,
    CHILD: 2,
    BACK_UP: 3,
  };
  const MAX_CONTROLGROUP_REGISTER = 8;

  // スケジュール種別
  const SCHEDULE_TYPE = {
    CW: 1,
    YOI_EN: 2,
  };

  // スケジュール作成・編集画面:
  // シーン再生条件
  const SCENE_PLAY_CONDITION = {
    NORMAL: '1',
    EVERY_HOUR: '2',
  };

  // シーン開始種別
  const SCENE_START_SETTING_TYPE = {
    TIME: '1',
    SUNSET: '2',
  };

  // シーン終了種別
  const SCENE_END_SETTING_TYPE = {
    TIME: '1',
    SUNRISE: '2',
    SPECIFIED: '3',
  };

  // 日出・日入の前後種別
  const SCENE_POINT_OPTION_TYPE = {
    FRONT: 1,
    BACK: 2,
  };

  // スケジュール毎正時設定における再生回数
  const SCHEDULE_EVERY_HOUR_PLAY_COUNT = {
    MIN: 1,
    MAX: 3599,
  };

  // 日出・日入の想定時間（YOI-enでの判定用として用いる）
  // 最終的には緯度経度と日付よりAREASによって日出・日入の計算時刻が計算され優先順位に従ってスケジュール再生が行われる
  const SCENE_ESTIMATED_TIME = {
    SUNRISE: '06:47:00', // 日出時刻
    SUNSET: '16:32:00', // 日入時刻
  };

  // REST APIのURI定義
  const URI = {
    // 【G-01】表示エリアG計測データの取得
    GET_AREA_GROUP_DATA: context.$config.uriAreaGroupData,
    // 【G-02】表示エリアG計測ログデータの取得
    GET_AREA_DATA: context.$config.uriAreaData,
    // 【G-04】エリア登録情報の取得
    GET_AREA_REGIST: context.$config.uriAreaRegist,
    // 【G-05】エリア登録情報の一覧取得
    GET_AREA_REGIST_LIST: context.$config.uriAreaRegistList,
    // 【G-06】エリア写真の取得
    GET_AREA_PHOTO: context.$config.uriAreaPhoto,
    // 【G-07】表示エリアG登録情報の取得
    GET_AREA_GROUP_REGIST: context.$config.uriAreaGroupRegist,
    // 【G-08】表示エリアG登録情報の一覧取得
    GET_AREA_GROUP_REGIST_LIST: context.$config.uriAreaGroupRegistList,
    // 【G-09】表示エリアGマップの取得
    GET_AREA_GROUP_MAP: context.$config.uriAreaGroupMap,
    // 【G-10】表示エリアGへのエリア登録情報の取得
    GET_AREA_GROUP_AREA: context.$config.uriAreaGroupArea,
    // 【G-11】件名登録情報の取得
    GET_PROJECT_REGIST: context.$config.uriProjectRegist,
    // 【G-13】異常通知設定の取得
    GET_ALARM: context.$config.uriAlarm,
    // 【G-14】異常通知設定の一覧取得
    GET_ALARM_LIST: context.$config.uriAlarmList,
    // 【G-15】休日カレンダー設定の取得
    GET_CALENDAR: context.$config.uriCalendar,
    // 【G-16】休日カレンダーの一覧取得
    GET_CALENDAR_LIST: context.$config.uriCalendarList,
    // 【G-17】閲覧権限の取得
    GET_VIEW_GROUP_SCOPE: context.$config.uriViewGroupScope,
    // 【G-18】閲覧権限の一覧取得
    GET_VIEW_GROUP_SCOPE_LIST: context.$config.uriViewGroupScopeList,
    // 【G-19】センサー登録情報の一覧取得
    GET_DEVICE_REGIST_LIST: context.$config.uriDeviceRegistList,
    // 【G-20】レベル判定設定の取得
    GET_JUDGEMENT_LEVEL: context.$config.uriJudgementLevel,
    // 【G-21】設定データの取得
    GET_SETTING_DATA: context.$config.uriSettingData,
    // 【P-01】エリア登録情報の設定
    POST_AREA_REGIST: context.$config.uriAreaRegist,
    // 【P-02】エリア写真の設定
    POST_AREA_PHOTO: context.$config.uriAreaPhoto,
    // 【P-03】表示エリアG登録情報の設定
    POST_AREA_GROUP_REGIST: context.$config.uriAreaGroupRegist,
    // 【P-04】表示エリアGマップの設定
    POST_AREA_GROUP_MAP: context.$config.uriAreaGroupMap,
    // 【P-05】表示エリアGへのエリア登録情報の設定
    POST_AREA_GROUP_AREA: context.$config.uriAreaGroupArea,
    // 【P-06】件名登録情報の追加
    POST_PROJECT_REGIST: context.$config.uriProjectRegist,
    // 【P-07】異常通知設定の設定
    POST_ALARM: context.$config.uriAlarm,
    // 【P-08】休日カレンダーの設定
    POST_CALENDAR: context.$config.uriCalendar,
    // 【P-09】閲覧権限の設定
    POST_VIEW_GROUP_SCOPE: context.$config.uriViewGroupScope,
    // 【P-10】表示エリアGの表示順序の設定
    POST_AREA_GROUP_ORDER: context.$config.uriAreaGroupOrder,
    // 【P-11】レベル判定設定の設定
    POST_JUDGEMENT_LEVEL: context.$config.uriJudgementLevel,
    // 【P-12】メンテナンス通知の設定
    POST_MAINTENANCE_NOTICE: context.$config.uriMaintenanceNotice,
    // 【P-13】テストメールの送信
    POST_TEST_MAIL: context.$config.uriTestMail,
    // 【E-01】エリア登録情報の削除
    DELETE_AREA_REGIST: context.$config.uriAreaRegist,
    // 【E-02】表示エリアG登録情報の削除
    DELETE_AREA_GROUP_REGIST: context.$config.uriAreaGroupRegist,
    // 【E-03】異常通知設定の削除
    DELETE_ALARM: context.$config.uriAlarm,
    // 【E-04】休日カレンダーの削除
    DELETE_CALENDAR: context.$config.uriCalendar,
    // 【E-07】エリア写真の削除
    DELETE_AREA_PHOTO: context.$config.uriAreaPhoto,
    // 【E-08】表示エリアGマップの削除
    DELETE_AREA_GROUP_MAP: context.$config.uriAreaGroupMap,
  };
  // HTTPレスポンスコード定義
  const STATUS_CODE = {
    SUCCESS: 200,
    ACCEPTED: 202,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    AUTHENTICATION_ERROR: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    NOT_ACCEPTABLE: 406,
    REQUEST_TIMEOUT: 408,
    CONFLICT: 409,
    PAYLOAD_TOO_LARGE: 413,
    UNSUPPORTED_MEDIA_TYPE: 415,
    RANGE_NOT_SATISFIABLE: 416,
    TOO_MANY_REQUESTS: 429,
    RESPONSE_ERROR: 452,
    INTERNAL_SERVER_ERROR_490: 490,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMIEOUT: 504,
    UNEXPECTED_ERROR_MAX: 599,
    FATAL_ERROR: 999,
  };
  // 汎用CONSTANT定義
  const CONSTANT = {
    // ローカルストレージのkey名称
    LOCAL_STORAGE_KEY: 'SolAppLocalData',
    // パターン1(混雑度・在不在)
    DISPLAY_PATTERN1: 1,
    // パターン2(温湿度,CO2)
    DISPLAY_PATTERN2: 2,
    // パターン3(CO2)
    DISPLAY_PATTERN3: 3,
    // パターン4(温湿度)
    DISPLAY_PATTERN4: 4,
    // パターン5(混雑度・在不在,室温度,CO2)
    DISPLAY_PATTERN5: 5,
    // パターン6(混雑度・在不在,CO2)
    DISPLAY_PATTERN6: 6,
    // パターン7(混雑度・在不在,温湿度)
    DISPLAY_PATTERN7: 7,
    // しきい値超過判定(0:正常, 1:異常)
    IS_ALARM: 1,
    // 登録判定(0:登録なし, 1:登録あり)
    NOT_REGISTERED: 0,
    IS_REGISTERED: 1,
    // 1日分の10分平均のログデータ数
    LOG_DATA_COUNT: 144,
    // REST APIのタイムアウト時間45秒
    TIMEOUT: 45000,
    // 登録エリアの設定最大数
    REGIST_AREA_SETTING_MAX: 20,
    // 通知先メールアドレスの設定最大数
    EMAIL_SEND_MAX: 3,
    // 表示エリアグループの設定最大数
    AREA_GROUP_SETTING_MAX: 30,
    // エリア登録の設定最大数
    AREA_REGIST_INFO_SETTING_MAX: 20,
    // エリア登録情報の設定最大数
    AREA_REGIST_INFO_LIST_MAX: 600,
    // 異常通知の設定値最大数
    ALARM_SETTING_MAX: 30,
    // 休日設定の設定最大数
    CALENDAR_SETTING_MAX: 30,
    // 休日設定の日付登録最大数
    CALENDAR_RIGST_MAX: 200,
    // 休日設定の日付のフォーマット
    CALENDAR_DAY_FORMAT: 'YYYY/MM/DD',
    // 閲覧グループの設定値最大数
    VIEW_GROUP_SETTING_MAX: 30,
    // 全表示エリアGを閲覧可能
    VIEW_GROUP_ALL_ENABLE: 0,
    // JPEG画像圧縮品質(85%)
    IMAGE_QUALITY_PERCENT: 85,
    // 画像サイズ(150KB)
    IMAGE_SIZE_KB_MAX: 150 * 1024,
    // 画像横幅最大値(356px)
    IMAGE_WIDTH_PX_MAX: 356,
    // 画像縦幅最大値(200px)
    IMAGE_HEIGHT_PX_MAX: 200,
    // 画像横幅最小値(50px):ピンの縦幅になる
    IMAGE_WIDTH_PX_MIN: 62.5,
    // 画像縦幅最小値(50px):ピンの縦幅になる
    IMAGE_HEIGHT_PX_MIN: 62.5,
    // ページネーション 1ページ当たりの項目数
    PAGENATION_LIST_MAX: 30,
    // ページネーション ページ範囲
    PAGENATION_PAGE_RANGE_MAX: 4,
    // 共通設定ページのURL
    LOGIN_PAGE_ADMIN: context.$config.urlCommonSetting,
    // 共通基盤ポータルのURL
    LOGIN_PAGE_PORTAL: context.$config.urlLoginPagePortal,
    // 共通基盤ポータルログアウトのURL
    LOGOUT_PAGE_PORTAL: context.$config.urlLogoutPagePortal,
    // KUKAN View 分析画面のURL(件名IDまでの前半部)
    ANALITICS_PAGE_PREFIX: context.$config.urlAnalyticsPagePrefix,
    // KUKAN View 分析画面のURL(件名IDからの後半部)
    ANALITICS_PAGE_SUFFIX: context.$config.urlAnalyticsPageSuffix,
    // ログインページ遷移までのタイムアウト時間
    LOGIN_REDIRECT_TIMEOUT: 5000,
    // 切り上げ、切り捨て対象の桁数定義: 1の位
    ROUND_UP_DOWN_ONES_PLACE: 1,
    // 切り上げ、切り捨て桁数の桁数定義: 10の位
    ROUND_UP_DOWN_TENS_PLACE: 2,
    // 時刻(HH:MM:SS)未設定・未取得時のデフォルト値
    DEFAULT_TIME_STRING: '00:00:00',
  };

  // VALIDATION定義
  const VALIDATION = {
    /* メンテナンスメッセージ登録 */
    // メンテナンスタイトル最大文字数
    MAINTENANCE_TITLE_MAX: 32,
    // メンテナンスメッセージ最大文字数
    MAINTENANCE_MESSAGE_MAX: 500,
    /* エリアグループ設定 */
    // エリアグループ名称 最大文字数
    AREA_GROUP_NAME_MAX: 20,
    /* エリア設定 */
    // エリア名称 最大文字数
    AREA_NAME_MAX: 20,
    // エリア定員最大数5000, 最小数0
    AREA_CAPACITY_MAX: 5000,
    AREA_CAPACITY_MIN: 1,
    // 最大値：時
    HOUR_MAX: 23,
    // 最大値：分
    MINUTES_MAX: 59,
    /* 休日設定 */
    // 日付の入力文字数(YYYY/MM/DD)
    CALENDAR_DAY_INPUT_LENGTH: 10,
    // 日付の最低年月日(2021/01/01)
    CALENDAR_DAY_LOWER_LIMIT: '2021/01/01',
    // カレンダー名称の最大入力文字数
    CALENDAR_NAME_MAX: 20,
    /* 混雑度設定 */
    // 混雑度閾値 最大値100, 最小値1
    CONGESTION_THRESHOLD_MAX: 100,
    CONGESTION_THRESHOLD_MIN: 1,
    // 在・不在閾値 最大値1.0, 最小値0.1
    EXIST_THRESHOLD_MAX: 1.0,
    EXIST_THRESHOLD_MIN: 0.1,
    /* 異常通知設定 */
    // 異常設定名最大値20
    ALARM_NAME_MAX: 20,
    // 異常保持時間最大値30, 最小値0
    ALARM_SAVE_TIME_MAX: 30,
    ALARM_SAVE_TIME_MIN: 0,
    // 異常再通知時間最大値30, 最小値0
    ALARM_RESEND_TIME_MAX: 600,
    ALARM_RESEND_TIME_MIN: 60,
    // 混雑度閾値最大値1000, 最小値1, デフォルト1000
    ALARM_CONGESTION_THRESHOLD_MAX: 1000,
    ALARM_CONGESTION_THRESHOLD_MIN: 1,
    ALARM_CONGESTION_THRESHOLD_DEF: 1000,
    // CO2閾値最大値10000, 最小値401, デフォルト10000
    ALARM_CO2_THRESHOLD_MAX: 10000,
    ALARM_CO2_THRESHOLD_MIN: 401,
    ALARM_CO2_THRESHOLD_DEF: 10000,
    // 騒音閾値最大値129, 最小値34,  デフォルト129
    ALARM_SOUND_THRESHOLD_MAX: 129,
    ALARM_SOUND_THRESHOLD_MIN: 34,
    ALARM_SOUND_THRESHOLD_DEF: 129,
    // 温度閾値最大値50, 最小値0, デフォルト上限50.0, 下限0.0
    ALARM_TEMPERATURE_THRESHOLD_MAX: 50.0,
    ALARM_TEMPERATURE_THRESHOLD_MIN: 0.0,
    ALARM_TEMPERATURE_THRESHOLD_UL_DEF: '50.0',
    ALARM_TEMPERATURE_THRESHOLD_LL_DEF: '0.0',
    // 湿度閾値最大値99.9, 最小値0.1, デフォルト上限99.9, 下限0.1
    ALARM_HUMIDITY_THRESHOLD_MAX: 99.9,
    ALARM_HUMIDITY_THRESHOLD_MIN: 0.1,
    ALARM_HUMIDITY_THRESHOLD_UL_DEF: 99.9,
    ALARM_HUMIDITY_THRESHOLD_LL_DEF: 0.1,
  };

  // レベル表示種別
  const HUMAN_TYPE = {
    // 混雑度
    CONGESTION: 0,
    // 在・不在
    EXIST: 1,
  };

  // 在・不在レベル種別
  const EXIST_LEVEL_TYPE = {
    // 0:不在、1:在
    NOT_EXIST: 0,
    EXIST: 1,
    NONE: '-',
  };

  // センサータイプ
  const SENSOR_TYPE = {
    // AIカメラ
    AI: 6,
    // 人感センサー
    SEAT: 5,
    // 電池タイプ
    BATTERY: 3,
    // USBタイプ
    USB: 2,
    // CO2センサー
    CO2: 4,
    // マグネットセンサー
    MAGNET: 13,
    // 全方位カメラ
    LINECROSS: 15,
  };

  // 混雑度の判定種別
  const HUMAN_COUNT_TYPE = {
    // 滞在人数
    STAY: 0,
    // 積算進入人数
    TOTAL_ADMISSION: 1,
    // 積算退出人数
    TOTAL_EXIT: 2,
    // 時間別進入人数
    ADMISSION: 3,
    // 時間別退出人数
    EXIT: 4,
  };

  // 表示期間種別
  const DISPLAY_PERIOD = {
    // 0:24時間表示
    PATTERN1: 0,
    // 1:8-19時表示(初期値)
    PATTERN2: 1,
    // 2:11-14時表示
    PATTERN3: 2,
  };

  // 画面名
  const DISPLAY = {
    // ブランク画面
    BLANK: 'blank',
    // 状況一覧画面
    GROUP_AREA_GROUP_ID: 'group-areaGroupId',
    // エリア詳細画面
    GROUP_AREA_GROUP_ID_AREA_INFO_ID: 'group-areaGroupId-areaInfoId',
    // 表示エリアグループ設定画面
    AREA_GROUP_SETTINGS: 'area-group-settings-edit',
    // エリア設定画面
    AREA_SETTINGS: 'area-settings-edit',
    // 休日設定画面
    HOLIDAY_SETTINGS: 'holiday-settings-edit',
    // 混雑度・在不在設定画面
    CONGESTION_SETTINGS: 'congestion-settings',
    // 異常通知設定画面
    NOTIFICATION_SETTINGS: 'notification-settings-edit',
    // 閲覧範囲設定画面
    RANGE_SETTINGS: 'range-settings-edit',
  };

  // 画面名
  const STORE = {
    // 表示エリアグループ設定画面
    AREA_GROUP_SETTINGS: 'page/AreaGroupSettingsEdit',
    // エリア設定画面
    AREA_SETTINGS: 'page/AreaSettingsEdit',
    // 休日設定画面
    HOLIDAY_SETTINGS: 'page/HolidaySettingsEdit',
    // 混雑度・在不在設定画面
    CONGESTION_SETTINGS: 'page/CongestionSettings',
    // 異常通知設定画面
    NOTIFICATION_SETTINGS: 'page/NotificationSettingsEdit',
    // 閲覧範囲設定画面
    RANGE_SETTINGS: 'page/RangeSettingsEdit',
    // メンテナンスメッセージ設定
    MAINTENANCE_MESSAGE_SETTINGS: 'page/MaintenanceMessageSettings',
    // 設定一括ダウンロード
    DOWNLOAD_SETTING: 'modal/DownloadSetting',
  };

  // マップピンのアイコンサイズ
  const MAP_PIN_SIZE = {
    // アイコンピンサイズの定義
    WIDTH: 43.75,
    HEIGHT: 62.5,
    HALF_WIDTH: 21.875,
    HALF_HEIGHT: 31.25,
  };

  // 管理者用の件名ID
  const SPECIAL_PROJECT = {
    PROJECT_ID: 99999,
  };

  // 休日設定の曜日
  const WEEK_INDEX = {
    SUN: 0,
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6,
  };

  // 休日設定の特日の種別
  const CALENDAR_TYPE = {
    HOLIDAY: 0,
    WORKDAY: 1,
  };

  // センサータイプ
  const CHART_TYPE = {
    // line
    LINE: 0,
    // bar
    BAR: 1,
  };

  // 日の入時刻
  const SUNSET_TIME = {
    // 時
    HOURS: 16,
    // 分
    MINUTES: 30,
    // 秒
    SECONDS: 0,
  };

  // 日の出時刻
  const SUNRISE_TIME = {
    // 時
    HOURS: 6,
    // 分
    MINUTES: 30,
    // 秒
    SECONDS: 0,
  };

  // getDay()から曜日名に変換
  // 多言語対応の際に対応の必要有り。
  const DAY_STRING = ['日', '月', '火', '水', '木', '金', '土'];
  // システム権限
  const SYSTEM_ROLE = {
    // 一般ユーザー
    USER: 1,
    // 件名管理者
    SUBJECT_MANAGER: 2,
    // エンジニアリング担当者
    ENGINEERING_MANAGER: 3,
    // システム運用担当者
    SYSTEM_OPERATOR: 4,
    // システム管理者
    SYSTEM_ADMINISTRATOR: 5,
  };

  // データ送受信画面のスケジュール・カレンダー・シーン送信ステータス
  const DATA_SEND_STATUS = {
    // 未送信
    NO_SEND: 0,
    // 送信中
    SEND_NOW: 1,
    // 送信成功
    SEND_SUCCESS: 2,
    // 送信失敗
    SEND_FAILED: 3,
    // 送信失敗（A2コントローラ）
    SEND_FAILED_A2: 4,
    // 送信失敗（内部エラー）
    SEND_FAILED_INTERNAL: 5,
  };

  // データ送受信画面のスケジュール・カレンダー・シーン受信ステータス
  const DATA_RECEIVE_STATUS = {
    // 未受信
    NO_RECEIVE: 0,
    // 受信中
    RECEIVE_NOW: 1,
    // 受信成功
    RECEIVE_SUCCESS: 2,
    // 受信失敗
    RECEIVE_FAILED: 3,
    // 受信失敗（A2コントローラ）
    RECEIVE_FAILED_A2: 4,
    // 受信失敗（内部エラー）
    RECEIVE_FAILED_INTERNAL: 5,
  };

  // 制御グループ一覧のカレンダー開始日・基準時刻ステータス
  const CALENDAR_START_AND_BASE_TIME_STATUS = {
    // 未受信
    NO_RECEIVE: 0,
    // 一致
    MATCH: 1,
    // 不一致
    NOT_MATCH: 2,
    // 失敗
    FAILED: 3,
  };

  // 機器監視
  const DEVICE_OPERATION_MENU = {
    // 操作メニュー
    OPERATION_MENU_BAR: -1,
    // 再起動
    REBOOT: 0,
    // シャットダウン
    SHUTDOWN: 1,
    // コントローラログ取得
    CONTROLLER_LOG: 2,
  };
  const DEVICE_ITEM_STATUS = {
    RUNNING: 0,
    STOPPED: 1,
    ERROR: 2,
  };
  const CONTROLLER_TYPE = {
    PARENT: 1,
    CHILDREN: 2,
    BK: 3,
  };
  // データ送信情報ファイルのファイル種別
  const DOWNLOAD_FILE_KIND = {
    NEW_SCHEDULE: 1,
    SCHEDULE_BIN: 2,
    CALENDAR_BIN: 3,
    SCENE_NAME: 4,
    SCENE_DATA_FILE: 5,
  };
  // データ受信情報ファイルのファイル種別
  const UPLOAD_FILE_KIND = {
    NEW_SCHEDULE: 1,
    CALENDAR_BIN: 3,
    SCENE_NAME: 4,
  };
  // データ送受信詳細の進捗ステータス
  const DATA_TRANSCEIVER_STATUS = {
    NOW: 1,
    SUCCESS: 2,
    FAILED: 3,
  };
  // データ送受信詳細の制御結果通知
  const DATA_TRANSCEIVER_RESULT = {
    NO_NOTIFIED: 0,
    SUCCESS: 1,
    FAILED: 2,
  };
  // バッチ実行種別
  const BATCH_KIND = {
    ALL_SEND: 0,
    SCHEDULE_CALENDAR_SEND: 1,
    SCENE_SEND: 2,
    RECEIVE: 3,
  };
  // 制御グループ詳細のシーン送信ステータス
  const SEND_SCENE_STATUS = {
    NO_SEND: 0,
    NOW: 1,
    SUCCESS: 2,
    FAILED: 3,
    FAILED_A2: 4,
    FAILED_ERR: 5,
  };
  // 制御グループ詳細のスケジュール送信ステータス
  const SEND_SCHEDULE_STATUS = {
    NO_SEND: 0,
    NOW: 1,
    SUCCESS: 2,
    FAILED: 3,
    FAILED_A2: 4,
    FAILED_ERR: 5,
  };
  // 制御グループ詳細のカレンダー送信ステータス
  const SEND_CALENDAR_STATUS = {
    NO_SEND: 0,
    NOW: 1,
    SUCCESS: 2,
    FAILED: 3,
    FAILED_A2: 4,
    FAILED_ERR: 5,
  };
  // 環境名
  const ENV_NAME = {
    LOCAL: 'local',
    DEV: 'dev',
    TEST: 'test',
    STG: 'stg',
    PROD: 'www',
  };
  // 環境別ドメイン名
  const ENV_DOMAIN = {
    LOCAL: 'localhost:3000',
    DEV: 'dev.yoien-platform.com',
    TEST: 'test.yoien-platform.com',
    STG: 'stg.yoien-platform.com',
    PROD: 'www.yoien-platform.com',
  };
  // YOI-en内部APIの環境別URL
  // TODO: 環境毎のAPI Gatewayが設定され次第設定する。
  const API_URL = {
    LOCAL: 'http://localhost:3000',
    LOCAL_PROXY: 'http://localhost:3300',
    DEV: 'https://dev.yoien-platform.com/dev',
    TEST: 'https://test.yoien-platform.com/test',
    STG: 'https://stg.yoien-platform.com/stg',
    PROD: 'https://www.yoien-platform.com/prod',
  };
  // クラウド共通基盤APIの環境別URL
  // TODO: 環境毎のAPI Gatewayが設定され次第設定する。
  const CLOUD_COMMON_API_URL = {
    LOCAL: 'http://localhost:3000',
    DEV: 'https://mock-portal.dev.yoien-platform.com/kukan/com/v1/idt',
    TEST: 'https://mock-portal.test.yoien-platform.com/kukan/com/v1/idt',
    STG: 'https://test-api-com.kukancloudservice.com/kukan/com/v1/idt',
    PROD: 'https://api-com.kukancloudservice.com/kukan/com/v1/idt',
  };
  // S3の一時ファイルアップロード用フォルダ名
  const TEMP_FOLDER_NAME = 'Temp/';
  // S3のプロトコル
  const S3_PROTOCOL = 's3://';
  // 共通基盤画面URL
  const CLOUD_COMMON_URL = {
    // 共通基盤件名切替画面URL
    CHANGE_PROJECT: 'https://{envName}portal.yoien-platform.com/#/index?id_token={idToken}',
    // 共通基盤共通設定画面URL
    SETTING:
      'https://{envName}admin.yoien-platform.com/#/index?p_id={projectId}&id_token={idToken}',
    // 共通基盤ログアウト画面URL
    LOGOUT: 'https://{envName}portal.yoien-platform.com/#/logout?id_token={idToken}',
    // 共通基盤ログイン画面URL
    LOGIN: 'https://{envName}portal.yoien-platform.com/#/pages/login',
  };
  // Modalを閉じる際の挙動
  const MODAL_CLOSE_TYPE = {
    // 全て閉じる
    ALL: 0,
    // ConfirmModalのみ閉じる
    CONFIRM: 1,
    // PopupAlertModalのみ閉じえる
    POPUP_ALERT: 2,
  };
  // コントローラ制御要求送信のbodyに設定するversionの値
  const PUT_SCENARIO_VERSION = '2024-04-01';

  // シーン合成の最大時間(600秒 = 10分)
  const SCENE_COMPOSITION_MAX_TIME = 600;

  // シーン確認画面のシーン再生停止待機秒数(ミリ秒)
  const SCENE_PLAY_STOP_WAIT_TIME = 10000;

  // 再生停止待機区分
  const SCENE_PLAY_STOP_WAIT_TYPE = {
    // なし
    NONE: 0,
    // 再生
    PLAY: 1,
    // 停止
    STOP: 2,
  };

  // 365日*5年+うるう年(2回)を正常範囲とする
  const MAX_CALENDER_EDIT_RANGE = 1827;

  // ZIPファイル内の合計ファイルサイズの上限（100MB)
  const MAX_TOTAL_FILE_SIZE = 1024 * 1024 * 100;

  // 異常履歴 日付フォーマット
  const ERROR_DATE_FORMAT = 'yyyy-MM-dd';

  return {
    provide: {
      EXTEND_TYPE: EXTEND_TYPE,
      CONTENT_ALLOW_EXTEND_TYPE: CONTENT_ALLOW_EXTEND_TYPE,
      RESOLUTION: RESOLUTION,
      VIDEO_SETTING: VIDEO_SETTING,
      FAVORITE_STATUS: FAVORITE_STATUS,
      SCENE_SORT_KEY: SCENE_SORT_KEY,
      SCENE_SORT_TYPE: SCENE_SORT_TYPE,
      CREATION_STATUS: CREATION_STATUS,
      SEND_STATUS: SEND_STATUS,
      SCENE_KIND_STATUS: SCENE_KIND_STATUS,
      CHECKED_STATUS: CHECKED_STATUS,
      CONTROLLER_SIZE: CONTROLLER_SIZE,
      DELETION_STATUS: DELETION_STATUS,
      CONTROLLER_DIVISION: CONTROLLER_DIVISION,
      MAX_CONTROLGROUP_REGISTER: MAX_CONTROLGROUP_REGISTER,
      SCHEDULE_TYPE: SCHEDULE_TYPE,
      SCENE_PLAY_CONDITION: SCENE_PLAY_CONDITION,
      SCHEDULE_EVERY_HOUR_PLAY_COUNT: SCHEDULE_EVERY_HOUR_PLAY_COUNT,
      SCENE_START_SETTING_TYPE: SCENE_START_SETTING_TYPE,
      SCENE_END_SETTING_TYPE: SCENE_END_SETTING_TYPE,
      SCENE_POINT_OPTION_TYPE: SCENE_POINT_OPTION_TYPE,
      SCENE_ESTIMATED_TIME: SCENE_ESTIMATED_TIME,
      URI: URI,
      STATUS_CODE: STATUS_CODE,
      CONSTANT: CONSTANT,
      VALIDATION: VALIDATION,
      HUMAN_TYPE: HUMAN_TYPE,
      EXIST_LEVEL_TYPE: EXIST_LEVEL_TYPE,
      SENSOR_TYPE: SENSOR_TYPE,
      HUMAN_COUNT_TYPE: HUMAN_COUNT_TYPE,
      DISPLAY_PERIOD: DISPLAY_PERIOD,
      DISPLAY: DISPLAY,
      STORE: STORE,
      MAP_PIN_SIZE: MAP_PIN_SIZE,
      SPECIAL_PROJECT: SPECIAL_PROJECT,
      WEEK_INDEX: WEEK_INDEX,
      CALENDAR_TYPE: CALENDAR_TYPE,
      CHART_TYPE: CHART_TYPE,
      OPERATION_STATUS: OPERATION_STATUS,
      CONNECTION_STATUS: CONNECTION_STATUS,
      DE2_STATUS: DE2_STATUS,
      SUNSET_TIME: SUNSET_TIME,
      SUNRISE_TIME: SUNRISE_TIME,
      DAY_STRING: DAY_STRING,
      SYSTEM_ROLE: SYSTEM_ROLE,
      DATA_SEND_STATUS: DATA_SEND_STATUS,
      DATA_RECEIVE_STATUS: DATA_RECEIVE_STATUS,
      CALENDAR_START_AND_BASE_TIME_STATUS: CALENDAR_START_AND_BASE_TIME_STATUS,
      DEVICE_OPERATION_MENU: DEVICE_OPERATION_MENU,
      DEVICE_ITEM_STATUS: DEVICE_ITEM_STATUS,
      CONTROLLER_TYPE: CONTROLLER_TYPE,
      CONNECTION_STATE: CONNECTION_STATE,
      EMIT_STATE: EMIT_STATE,
      LAMP_STATE: LAMP_STATE,
      LOG_LEVEL: LOG_LEVEL,
      DOWNLOAD_FILE_KIND: DOWNLOAD_FILE_KIND,
      UPLOAD_FILE_KIND: UPLOAD_FILE_KIND,
      DATA_TRANSCEIVER_STATUS: DATA_TRANSCEIVER_STATUS,
      DATA_TRANSCEIVER_RESULT: DATA_TRANSCEIVER_RESULT,
      BATCH_KIND: BATCH_KIND,
      SEND_SCENE_STATUS: SEND_SCENE_STATUS,
      SEND_SCHEDULE_STATUS: SEND_SCHEDULE_STATUS,
      SEND_CALENDAR_STATUS: SEND_CALENDAR_STATUS,
      ENV_NAME: ENV_NAME,
      ENV_DOMAIN: ENV_DOMAIN,
      API_URL: API_URL,
      CLOUD_COMMON_API_URL: CLOUD_COMMON_API_URL,
      TEMP_FOLDER_NAME: TEMP_FOLDER_NAME,
      S3_PROTOCOL: S3_PROTOCOL,
      CLOUD_COMMON_URL: CLOUD_COMMON_URL,
      MODAL_CLOSE_TYPE: MODAL_CLOSE_TYPE,
      PUT_SCENARIO_VERSION: PUT_SCENARIO_VERSION,
      SCENE_COMPOSITION_MAX_TIME: SCENE_COMPOSITION_MAX_TIME,
      SCENE_PLAY_STOP_WAIT_TIME: SCENE_PLAY_STOP_WAIT_TIME,
      SCENE_PLAY_STOP_WAIT_TYPE: SCENE_PLAY_STOP_WAIT_TYPE,
      MAX_CALENDER_EDIT_RANGE: MAX_CALENDER_EDIT_RANGE,
      MAX_TOTAL_FILE_SIZE: MAX_TOTAL_FILE_SIZE,
      ERROR_DATE_FORMAT: ERROR_DATE_FORMAT,
    },
  };
});
